import { Component } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css']
})

/**
 * Component for confirmation dialog.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class ConfirmationDialogComponent {

    message: string = '';
    title: string = '';

    constructor(public dialogRef: MdDialogRef<any>) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirmationdialog/confirmation-dialog.component.ts